var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',{attrs:{"title":"Versão do sistema "}},[_c('b-card-text',[_vm._v(" Versão atual: "+_vm._s(_vm.appVersion)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }